import { CommonModule } from "@angular/common";
import { Component, forwardRef, inject, input, OnInit } from "@angular/core";
import {
  ControlContainer,
  ControlValueAccessor,
  FormGroup,
  FormGroupDirective,
  FormsModule,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
} from "@angular/forms";
import { MaterialModule } from "src/app/core/material/material.module";
import { LabelInputComponent } from "../../label-input/label-input.component";

@Component({
  selector: "app-input",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    LabelInputComponent,
  ],
  providers: [],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputComponent),
    },
  ],
  templateUrl: "./input.component.html",
})
export class InputComponent implements OnInit, ControlValueAccessor {
  // Variables
  form: FormGroup = new FormGroup({});

  // Services
  private parent = inject(FormGroupDirective);
  ngControl = inject(NgControl, { optional: true, self: true })!;

  // Inputs
  readonly nameControl = input<string>();
  readonly textLabel = input<string>();
  readonly required = input<boolean>(false);
  readonly maxlength = input<any>("255");
  readonly type = input<string>("text");
  readonly value = input<any>();
  readonly textTooltip = input<string>();
  readonly hasTooltip = input<boolean>(false);
  readonly hasButtonCopy = input<boolean>(false);
  readonly placeholder = input<string>("");
  readonly disabled = input<boolean>(false);
  readonly textRequired = input<string>("");

  get f() {
    return this.form.controls;
  }

  constructor() {
    if (this.ngControl != null) this.ngControl.valueAccessor = this;
  }

  writeValue(value: any): void {
    if (this.f[this.nameControl()!]) {
      this.f[this.nameControl()!].setValue(value);
    }
  }

  onChange: (_: any) => void = (value: any) => {
    if (this.f[this.nameControl()!]) {
      this.f[this.nameControl()!].setValue(value);
    }
  };

  onTouched: () => void = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit() {
    this.form = this.parent.form;
  }

  onChangeBlur() {
    this.f[this.nameControl()!].setValue(
      this.f[this.nameControl()!].value?.trim()
    );
  }
}
